import { Button, Text } from '@ksyos/design-system';
import { useState } from 'react';
import type { IProcedureAddEdit } from '../../../procedures/ProcedureItemAddEdit';
import { translateKey } from '../../../../../translate';
import { Modal } from '../../../../elements/modals/Modal';

interface IOrthOFolConvertToConsultButtonProps {
    onConfirm: () => void;
    procedure: IProcedureAddEdit;
}
export function OrthOFolConvertToConsultButton(props: IOrthOFolConvertToConsultButtonProps) {
    const [showModal, setShowModal] = useState(false);

    if (props.procedure.customControlData.consult) {
        return <></>;
    }

    const buttonText = 'Maak vervolgconsult';

    return (
        <>
            <Button
                onClick={async () => {
                    if (!showModal) {
                        setShowModal(true);
                    }
                }}
                variant="outline"
            >
                {buttonText}
            </Button>

            <Modal
                actionButtons={[
                    <Button
                        onClick={() => setShowModal(false)}
                        variant="outline"
                    >
                        {translateKey('diagnosticReport.cancelDiagnosticReport')}
                    </Button>,
                    <Button
                        onClick={async () => {
                            props.onConfirm();
                            setShowModal(false);
                        }}
                    >
                        {buttonText}
                    </Button>,
                ]}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                size="medium"
                title="Vervolgconsult aanmaken"
            >
                <Text>
                    Let op: je gaat een vervolgconsult aanmaken met een oogarts. Indien je het vervolgconsult later
                    annuleert, gaat het onderzoek verloren.
                </Text>
            </Modal>
        </>
    );
}
